import Button from '@/presentation/components/elements/Button';
import Icon, { Icons } from '@/presentation/components/elements/Icon';
import { useNetwork } from '@/presentation/context/network';
import { Address } from 'nftx.js';

const WithdrawLiquiditySuccess = ({
  onClose,
  txHash,
}: {
  onClose: () => void;
  txHash?: Address;
}) => {
  const { chain } = useNetwork();

  return (
    <div className="py-6 bg-gray-50 max-w-lg mx-auto space-y-4">
      <h2 className="text-lg text-center mb-2 font-bold">{'Success'}</h2>
      <div className="p-2 flex justify-center items-center">
        <Icon name={Icons.CHECK} size={48} className="text-green-500" />
      </div>
      <p className="text-center">
        {'You have successfully withdrawn your liquidity.'}
      </p>
      <p className="text-center">
        <a
          href={`${chain.blockExplorers?.default.url}/tx/${txHash}`}
          target="_blank"
          rel="nofollow noreferrer"
          className="underline hover:no-underline text-gray-600 text-sm"
        >
          {'View transaction'}
        </a>
      </p>
      <div className="mb-4 flex justify-center">
        <Button type="button" variant="primary" onClick={onClose}>
          {'Close'}
        </Button>
      </div>
    </div>
  );
};

export default WithdrawLiquiditySuccess;
